<!--
 * @Author: jixiaoyong
 * @Email: jixiaoyong1995@gmail.com
 * @Date: 23/07/29
 * @LastEditors: jixiaoyong
 * @LastEditTime: 24/05/30
 * @FilePath: /app_list/src/components/HomePage.vue
 * @Description: 展示各个 app 的信息及下载链接
 * 
 * Copyright (c) 2024 by jixiaoyong, All Rights Reserved. 
-->
<template>
  <div>
    <div class="app-bar-title">APP 生产包下载链接 <button @click="navigateToEditor">编辑✍️</button></div>
    <div class="app-bar-subtitle">此文档最后一次更新于：{{ lastUpdated }}</div>
  </div>
  <div v-if="Object.keys(downloadLinks).length === 0">
    <div class="loading-text">
      <div>
        LOADING...
        <div class="loader"></div>
      </div>
    </div>
  </div>
  <div v-else>
    <table>
      <tr v-for="n in Math.ceil(Object.keys(downloadLinks).length / rowCount)" :key="n">
        <td v-for="i in rowCount" :key="i" :set="((appName = Object.keys(downloadLinks)[(n - 1) * rowCount + i - 1]),
          (appLink = downloadLinks[appName]))
          ">
          <div v-if="appName != null" class="download-btn-container" :style="{
            flexDirection: isSmallScreen ? 'column' : 'row',
          }">
            <div class="download-container-left">
              <div style="font-size: 30px; color: #2fbe5e; font-weight: bolder">
                {{ appName }}
                <div class="app-version">{{ getVersion(appLink) }}</div>
              </div>
              <div class="download-btn" @click="
                download(
                  downloadLinks[
                  Object.keys(downloadLinks)[(n - 1) * rowCount + i - 1]
                  ]
                )
                " :key="appLink">
                点击下载
              </div>
              <div class="download-link">
                {{ appLink }}
              </div>
            </div>
            <div class="download-container-right">
              <qrcode-vue :value="appLink" :size="150" level="H" />
            </div>
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>

<script setup>
import { getVersion } from '@/utils/util';
import { onMounted, onUnmounted, ref } from "vue";
import { useRouter } from 'vue-router';

import axios from "axios";
import QrcodeVue from "qrcode.vue";

// 响应式状态
var downloadLinks = ref({});
var lastUpdated = ref("[更新时间加载中……]");

function download(link) {
  console.log("download link:" + link);
  window.location.href = link;
}

onMounted(() => {
  window.addEventListener("resize", handleResize);
  axios
    .get(`./config.json`)
    .then((response) => {
      const data = response.data.data;
      for (let i = 0; i < data.length; i++) {
        const item = data[i];
        downloadLinks.value[item.name] = item.link;
      }
      lastUpdated.value = response.data.lastUpdateTime;
    })
    .catch((error) => {
      console.error(error);
    });
});

onUnmounted(() => {
  window.removeEventListener("resize", handleResize);
});

const isSmallScreen = ref(window.innerWidth <= 760);
const rowCount = ref(window.innerWidth >= 1200 ? 2 : 1);

const handleResize = () => {
  console.log("window.innerWidth", window.innerWidth);
  isSmallScreen.value = window.innerWidth <= 760;
  rowCount.value = window.innerWidth >= 1200 ? 2 : 1;
};

const router = useRouter();

const navigateToEditor = () => {
  router.push({ path: '/editor' });
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.app-bar-title {
  font-size: 30px;
  color: #0b983a;
  font-weight: bolder;
  text-align: center;
  margin-top: 60px;
}

.app-bar-subtitle {
  font-size: 12px;
  font-weight: normal;
  margin-top: 10px;
  color: #2c3e50;
}

.loading-text {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20%;
}

.loader {
  border: 12px solid #f3f3f3;
  border-top: 12px solid #0b983a;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  margin-top: 20px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.app-version {
  text-align: center;
  color: white;
  padding-left: 8px;
  padding-right: 8px;
  padding-top: 5px;
  padding-bottom: 5px;
  background-color: #0b983a;
  border-radius: 20px;
  font-size: 12px;
  margin-left: 10px;
  margin-top: 5px;
  display: inline-block;
  position: absolute;
}

.btn-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}

.download-btn-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 80%;
  width: 80%;
  margin-top: 6%;
  margin-left: 5%;
  margin-right: 5%;
  justify-content: space-between;
  padding: 5%;
  border-radius: 10px;
  border: 2px solid #2fbe5e;
}

.download-btn:hover {
  background-color: #2fbe5e;
  border: 2px solid #2fbe5e;
  color: white;
  font-weight: bolder;
}

.download-container-left {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.download-container-right {
  height: 100%;
  margin-top: 2%;
  text-align: center;
}

.download-btn {
  width: 300px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  margin: 20px;
  border-radius: 30px;
  background-color: white;
  border: 2px solid #2fbe5e;
  cursor: pointer;
}

.qr-code {
  margin-top: 10px;
  width: 190px;
  height: 190px;
}

.download-link {
  word-wrap: break-word;
  word-break: break-all;
  height: auto;
  max-width: 80%;
  font-size: small;
  margin-bottom: 10px;
}
</style>
